import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { classNames, Spacing } from '@vkontakte/vkui';
import React, { useEffect, useRef, useState } from 'react';
import { clamp } from 'reactApp/utils/mathHelpers';

import styles from './OverquotaFilesModal.css';

interface Props {
    isMobile: boolean;
    spaceLeft: number;
    availableSpace: number;
}

const ANIMATION_TIMEOUT_MS = 500;
const ANIMATION_DURATION_MS = 600;

export const OverquotaSubscriptionWidget = ({ isMobile, spaceLeft, availableSpace }: Props) => {
    const messages = {
        willRemain: `Останется ${bytesToNDigits(spaceLeft, 3).value}`,
        totalSpace: `Сейчас у вас ${bytesToNDigits(availableSpace, 3).value}`,
    };

    const baseRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const lineLeftRef = useRef<HTMLDivElement>(null);
    const lineRightRef = useRef<HTMLDivElement>(null);
    const hiddenRef = useRef<HTMLDivElement>(null);

    const [text, setText] = useState(messages.totalSpace);

    const remainingWidth = clamp((spaceLeft / (availableSpace + spaceLeft)) * 100, 8, 92);
    const totalWidth = clamp((availableSpace / (availableSpace + spaceLeft)) * 100, 8, 92);

    useEffect(() => {
        if (baseRef.current && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const textWidth = hiddenRef.current?.getBoundingClientRect().width || (isMobile ? 115 : 125);
            baseRef.current.style.right = `${containerRect.width - textWidth}px`;
        }

        if (lineLeftRef.current && lineRightRef.current) {
            lineLeftRef.current.style.width = `${remainingWidth}%`;
            lineRightRef.current.style.width = `${totalWidth}%`;
        }

        const id = setTimeout(() => {
            setText(messages.willRemain);
        }, ANIMATION_TIMEOUT_MS + ANIMATION_DURATION_MS / 3);

        return () => clearTimeout(id);
    }, []);

    return (
        <>
            <div className={styles.line}>
                <div className={classNames(styles.blue, styles.line_left)} ref={lineLeftRef} />
                <div className={classNames(styles.pink, styles.line_right)} ref={lineRightRef} />
            </div>
            <Spacing size={12} />
            <div className={styles.subtitle_container} ref={containerRef}>
                <div className={classNames(styles.subtitle, styles.total)}>
                    <span>{messages.totalSpace}</span>
                    <span className={classNames(styles.pink, styles.point)} />
                </div>
                <div className={classNames(styles.subtitle, styles.base)} ref={baseRef}>
                    <span className={classNames(styles.blue, styles.point)} />
                    <span className={styles.fading_text}>{text}</span>
                </div>

                <div className={classNames(styles.subtitle, styles.hidden_element)} ref={hiddenRef}>
                    <span className={classNames(styles.blue, styles.point)} />
                    <span className={styles.fading_text}>{messages.willRemain}</span>
                </div>
            </div>
        </>
    );
};
